import {
  ADD_DEPARTMENT,
  DELETE_DEPARTMENT,
  FETCH_DEPARTMENTS,
  UPDATE_DEPARTMENT,
} from "./action";
import initialState from "./initial.value";

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "Product_list":
      return { ...state, product_list: action.payload };
    case "Dashbaord_RecentProduct":
      return { ...state, dashboard_recentproduct: action.payload };
    case "Dashbaord_ExpiredProduct":
      return { ...state, dashboard_expiredproduct: action.payload };
    case "Salesdashbaord_ExpiredProduct":
      return { ...state, saleshdashboard_recenttransaction: action.payload };
    case "Brand_list":
      return { ...state, brand_list: action.payload };
    case "Unit_Data":
      return { ...state, unit_data: action.payload };
    case "Variantattribute_Data":
      return { ...state, variantattributes_data: action.payload };
    case "Warranty_Data":
      return { ...state, warranty_data: action.payload };
    case "Barcode_Data":
      return { ...state, barcode_data: action.payload };

    case "Department_Data":
      return { ...state, departmentlist_data: action.payload };

    case "Designation_Data":
      return { ...state, designation_data: action.payload };
    case "Shiftlist_Data":
      return { ...state, shiftlist_data: action.payload };
    case "Attendenceemployee_Data":
      return { ...state, attendenceemployee_data: action.payload };
    case "toggle_header":
      return { ...state, toggle_header: action.payload };
    case "Invoicereport_Data":
      return { ...state, invoicereport_data: action.payload };
    case "Salesreturns_Data":
      return { ...state, salesreturns_data: action.payload };
    case "Quatation_Data":
      return { ...state, quotationlist_data: action.payload };
    case "customer_data":
      return { ...state, customerdata: action.payload };
    case "Userlist_data":
      return { ...state, userlist_data: action.payload };
    case "Rolesandpermission_data":
      return { ...state, rolesandpermission_data: action.payload };
    case "Deleteaccount_data":
      return { ...state, deleteaccount_data: action.payload };
    case "Attendenceadmin_data":
      return { ...state, attendanceadmin_data: action.payload };
    case "Leavesadmin_data":
      return { ...state, leavesadmin_data: action.payload };
    case "Leavestype_data":
      return { ...state, leavetypes_data: action.payload };
    case "Holiday_data":
      return { ...state, holiday_data: action.payload };
    case "Expiredproduct_data":
      return { ...state, expiredproduct_data: action.payload };
    case "Lowstock_data":
      return { ...state, lowstock_data: action.payload };
    case "Categotylist_data":
      return { ...state, categotylist_data: action.payload };
    case "Layoutstyle_data":
      return { ...state, layoutstyledata: action.payload };
    //region pereco

    //region Applicant tracking
    case "applicant_tracking_clients_data":
      return { ...state, applicant_tracking_clients_data: action.payload };

    case "Applicant_Tracking_Jobs_Data":
      return { ...state, applicant_tracking_jobs_data: action.payload };

    case "Applicant_Tracking_Applicants_Data":
      return { ...state, applicant_tracking_applicants_data: action.payload };

    case "Applicant_Tracking_Job_Categories_Data":
      return {
        ...state,
        applicant_tracking_job_categories_data: action.payload,
      };
    case "Applicant_Tracking_Placements_Data":
      return { ...state, applicant_tracking_placements_data: action.payload };

    //region Rollcall

    case FETCH_DEPARTMENTS:
      console.log("Reducer Updating State:", action.payload);
      return { ...state, departmentList: action.payload };

    case ADD_DEPARTMENT:
      return {
        ...state,
        departmentList: [...state.departmentList, action.payload],
      };

    case UPDATE_DEPARTMENT:
      return {
        ...state,
        departmentList: state.departmentList.map((dept) =>
          dept.departmentid === action.payload.departmentid
            ? action.payload
            : dept
        ),
      };

    case DELETE_DEPARTMENT:
      return {
        ...state,
        departmentList: state.departmentList.filter(
          (dept) => dept.departmentid !== action.payload
        ),
      };

    case "rollcall_holidays":
      return { ...state, rollcall_holidays: action.payload };

    case "rollcall_registration_list":
      return { ...state, rollcall_registration_list: action.payload };
    case "Rollcall_Rejoinemployees_list":
      return { ...state, rollcall_rejoinemployees_list: action.payload };
    case "rollcall_employees_list":
      return { ...state, rollcall_employees_list: action.payload };
    case "Rollcall_Manual_AttendanceList":
      return { ...state, rollcall_manual_attendanceList: action.payload };

    case "Rollcall_EmployeeAccessList":
      return { ...state, rollcall_employees_accessList: action.payload };
    case "Rollcall_AssignshiftsList":
      return { ...state, rollcall_assignshifts_list: action.payload };
    case "RollCall_Daily_Attedance_Report":
      return { ...state, RollCall_Daily_Attedance_Report: action.payload };
    case "RollCall_Break_details_reports":
      return { ...state, RollCall_Break_details_reports: action.payload };
    case "RollCall_Break_Summary_Report":
      return { ...state, RollCall_Break_Summary_Report: action.payload };
    case "Rollcall_Punches_DayByDay_Reports":
      return { ...state, Rollcall_Punches_DayByDay_Reports: action.payload };
    case "Rollcall_Monthly_Summary_report":
      return { ...state, Rollcall_Monthly_Summary_report: action.payload };
    case "Rollcall_Attaedance_InOut_Report":
      return { ...state, Rollcall_Attaedance_InOut_Report: action.payload };
    case "rollcall_Leave_Details":
      return { ...state, rollcall_Leave_Details: action.payload };
    case "rollcall_leave_accurals":
      return { ...state, rollcall_leave_accurals: action.payload };
    case "rollcall_leave_summary":
      return { ...state, rollcall_leave_summary: action.payload };
    case "rollcall_leave_types":
      return { ...state, rollcall_leave_types: action.payload };

    default:
      return state;
  }
};

export default rootReducer;
